export default __webpack_public_path__ + "static/media/s2_female.c5a90290.wav";